<template>
  <div>
    <v-container class="py-10">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <h2>16. Potenzial von Zukunftstechnologien - "Deep Dive" 1</h2>
          <p></p>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "UseFutureTechDD1",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text: "Potenzial von Zukunftstechnologien"
        },
        xAxis: {
          categories: [
            "Freizeit und Geselligkeit",
            "Wirtschafts- und Berufsverbände",
            "Wissenschaft und Forschung"
          ]
        },
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        colors: ["#444", "#7d9b38"],
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> <br />',
          shared: true
        },
        plotOptions: {
          column: {
            stacking: "percent"
          }
        },
        series: [
          {
            name: "Nutzen Zukunftstechnologien nicht",
            data: [72.73, 47.83, 42.86]
          },
          {
            name: "Nutzen Zukunftstechnologien bereits",
            data: [27.27, 52.17, 57.14]
          }
        ]
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
